import React, { Fragment } from "react";
import YesIcon from "@material-ui/icons/Check";
import NoIcon from "@material-ui/icons/Block";
import { green, red } from "@material-ui/core/colors";
import { Box } from "@material-ui/core";

const YesNoCard = ({ value, showNoIcon = true }) => {
  return (
    <Box>
      {value ? (
        <Fragment>
          <YesIcon
            aria-label="yes"
            fontSize="large"
            style={{ color: green[500] }}
          />
        </Fragment>
      ) : showNoIcon ? (
        <Fragment>
          <NoIcon
            aria-label="no"
            fontSize="large"
            style={{ color: red[500] }}
          />
        </Fragment>
      ) : (
        <Fragment />
      )}
    </Box>
  );
};

export default YesNoCard;
